import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    paletaTonsAzul,
} from '../../../business-const/Color/Color'

import {
    GridContainer,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'



const PlanejamentoEspecializacaoPeriodoSabaticoChart = ( { values, estudo, report } ) => {

    const GridGrafico = report ? GridItem11 : GridItem11

    const PlanejamentoEspecializacaoPeriodoSabatico = ( props ) => {

        const series = []

        const data = []

        const categories = []

        const anoFinalGrafico = Number.parseInt(values.planejamentoEspecializacaoPeriodoSabatico.mesAnoFinalAcumulacao.substring(2)) + 10

        estudo.current.graficoIndependenciaFinanceiraSituacaoAtual?.forEach( (linhaGraficoIndependenciaFinanceiraSituacaoAtual, index) => {
            
            if (estudo.current.graficoAnos[index] <= anoFinalGrafico) {
            
                data.push(linhaGraficoIndependenciaFinanceiraSituacaoAtual)

                categories.push(estudo.current.graficoIdadesGraficos[index])
            }
        })

        series.push(
            {
                name: LABEL.fluxoCaixa,
                type: "area",
                data: data,
            },
        )
    


        return (
            <div
                {...props}
            >
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={""}
                            type="area"
                            series={series}
                            stacked={true}
                            categories={categories}
                            paletaCores={paletaTonsAzul}
                            notInverseOrder={true}
                            strokeWidth={0}
                            toolTipX={true}
                            toolTipXTotal={true}
                            report={report}
                            formatoReport={values.formatoReport}
                            participacao={true}
                        />
                    </GridGrafico>
                </GridContainer>
            </div>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <PlanejamentoEspecializacaoPeriodoSabatico
                        className='mt-5 ml-5'
                    />
                :
                    <PlanejamentoEspecializacaoPeriodoSabatico />
            }
        </GridItem12>
    )
}

export default PlanejamentoEspecializacaoPeriodoSabaticoChart